require("slick-carousel")

class window.ProductionPage
  constructor: ->
    @init()

  init: =>
    @initStaticSlider()
    @initProductionPage()

  initStaticSlider: ->
    $('.article-slider-block').each ->
      $(this).slick({
        slide: '.article-slide',
        nextArrow: $(this).parent('.article-slider-container').find('.article-slider__arrow-back')
        prevArrow: $(this).parent('.article-slider-container').find('.article-slider__arrow-next')
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        adaptiveHeight: true
      })
      $(this).on 'init reInit afterChange setPosition', (event, slick, currentSlide) ->
        padFromDiv = $(this).parent('.article-slider-container').find('.slick-arrow').height()/2
        padFromText = $(this).parent('.article-slider-container').find('.article-image-container__description').height()
        newY = ($(this).parent('.article-slider-container').find('.slick-list').height()/2) - padFromDiv - padFromText
        $(this).parent('.article-slider-container').find('.slick-arrow').css 'top', newY
        return

  initProductionPage: ->
    self = this
    targetElement = ".animate[data-doc-ready]"
    @initElementsAnimation(targetElement,'animate-element--slow-vertical')
    @initElementsAnimation(targetElement,'animate-element--slow')

    $(window).scroll ->
      targetElement = ".production-page__indicators .animate"
      if $(window).scrollTop() > $('.production-page__steps')[0].offsetTop
        self.initElementsAnimation(targetElement,'animate-element--slow')

  initElementsAnimation: (targetElement, animationClass) ->
    $('.production-page').find(targetElement).each ->
      animationIndex = $(this).attr('data-animation-index')
      window.Animations.animateElement($(this), animationIndex, 75, animationClass)



// WEBPACK FOOTER //
// ./assets/javascripts/app/production-page.coffee